function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdsbProblem = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "480pt",
    height: "480pt",
    viewBox: "0 0 480 480",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 160 40 L 193.984375 149.21875 L 324.765625 280 L 400 280 C 422.1875 280 440 262.03125 440 240 C 440 217.96875 422.1875 200 400 200 L 300 200 L 200 40 Z M 74.140625 85.859375 L 45.859375 114.140625 L 131.71875 200 L 100 200 L 70 160 L 40 160 L 60 240 L 40 320 L 70 320 L 100 280 L 209.765625 280 L 160 440 L 200 440 L 266.09375 334.375 L 365.859375 434.140625 L 394.140625 405.859375 L 267.96875 279.6875 L 188.59375 200 L 188.28125 200 Z "
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdsbProblem);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adsb_problem.8ce4b233b4aa79af8f49dc1020694c23.svg";